import PropTypes from 'prop-types';
import { useState } from 'react';

const proxyUri = '//images.weserv.nl/?url=';
const formatImageSource = (src, doUseProxy) => {
  if (!src || !doUseProxy) return src;
  return `${proxyUri}${src}`;
};

const Image = ({ src, title, doUseProxyProvider, className }) => {
  const [imageSource] = useState(formatImageSource(src, doUseProxyProvider));
  const [hasError, setHasError] = useState(false);
  const handleError = () => {
    setHasError(true);
  };

  if (!imageSource) {
    return (
      <div className="bg-gray-300 w-full h-full flex items-center justify-center email-hidden-field">
        No image
      </div>
    );
  }

  return (
    <>
      {imageSource && (
        <img
          src={imageSource}
          title={title}
          alt={title}
          onError={handleError}
          className={className}
        />
      )}

      {(!imageSource || hasError) && (
        <div className="bg-gray-300 w-full h-full flex items-center justify-center">No image</div>
      )}
    </>
  );
};

Image.propTypes = {
  src: PropTypes.string,
  title: PropTypes.string,
  doUseProxyProvider: PropTypes.bool,
  className: PropTypes.string,
};

Image.defaultProps = {
  src: undefined,
  title: undefined,
  doUseProxyProvider: true,
  className: '',
};

export default Image;
